<div class="accordion" role="tablist" #accordionToRemove [ngClass]="{'invalid-Accord':showError}">
	<h4 id="accordion-tab-{{accordIndexToAppend}}" (click)="hide()" class="accordion-toggle custom-accordion" [class.active]="accordianData.selected"
	 [attr.aria-selected]="accordianData.selected" [attr.aria-expanded]="accordianData.selected" role="tab" tabindex="0">
		{{accordionTittle}}
	</h4>
	<div id="accordion-tab-{{accordIndexToAppend}}-content" class="row accordion-content inner-flex-container" 
	    [class.active]="accordianData.selected" [attr.aria-hidden]="accordianData.selected"
	 role="tabpanel">
	 <div class="reduce-width question-style normal-ques-style newPos form-validation-error" *ngIf="showError">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p aria-hidden="false" role="error" aria-live="polite">Please answer all the required questions about this heart condition</p>
    </div>
		<div class="question-style normal-ques-style">
			<span> {{accordionQuesObj.questionText}} </span>
			<div class="info-icon">
				<app-tool-tip-notification *ngIf="accordionQuesObj.helpText" [childId]="accordionQuesObj.id" [tooltipData]="tooltipObj" 
				(onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
				</app-tool-tip-notification>
			</div>
		</div>
	
		<div class="col-md-12 inner-border">  
			<ng-template accordion-dir></ng-template>
		</div>
		 <!-- <button class="btn btn-secondary btn-sm" *ngIf ="showAddBtnFlag" (click)="addAnotherAccordion()">
			<i class="icon icon-plus delete-icon" aria-hidden="true"></i>Add</button> -->
		<button class="btn btn-secondary btn-sm" *ngIf ="showDeleteBtnFlag" (click)="delete()">
			<i class="icon icon-bin delete-icon" aria-hidden="true"></i>Delete</button>
	</div>
	<!-- modal popup-->
	 <modal-mw *ngIf="isDelete" [modalConfig]="heartModalConfig" (closeModal)="closedDeleteModal()" (primaryBtnClick)="deleteMedication()"
	 (secondaryBtnClick)="cancel()" [saveDataFlag]="false">
	</modal-mw> 
	
</div>
